import { useTranslation } from 'react-i18next';
import { MarketingPage, Section } from './MarketingPage';

const STEPS = ['guests', 'venues', 'money', 'checklist', 'day'] as const;

export function HowItWorks() {
  const { t } = useTranslation();
  return (
    <MarketingPage title={t('marketing.how.title')} lede={t('marketing.how.lede')}>
      {STEPS.map((step) => (
        <Section key={step} heading={t(`marketing.how.${step}.title`)}>
          <p>{t(`marketing.how.${step}.body`)}</p>
        </Section>
      ))}
    </MarketingPage>
  );
}
